import React, { useRef, useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import './question.css';
import { GetQuestions } from '../../utils/api';

//icon
import Ranking from '../../assets/icons/ranking.svg';

export default function Question({ questionsList }) {
  useEffect(() => {
    console.log('questionsList', questionsList);
  }, [questionsList]); 
  function convertToPersianNumbers(input) {
    if (input) {

      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }
  }
  return (
    <>
      <div className='mx-auto qus-box container'>
        <div className='d-flex align-items-center gap-2 mx-3'>
          <img src={Ranking} alt="" />
          <span className='text-[32px] text-[#00a14b] font-bold'>سوالات متداول</span>
        </div>
        <Accordion flush>
          {questionsList.length > 0 && (
            questionsList.map((item, index) => (
              <Accordion.Item eventKey={index} key={index}> 
                <Accordion.Header>{convertToPersianNumbers(item.Question)}</Accordion.Header>
                <Accordion.Body>
                  {convertToPersianNumbers(item.Answer)}
                </Accordion.Body>
              </Accordion.Item>
            ))
          ) }
        </Accordion>
      </div>
    </>
  );
}
